module.exports = __webpack_public_path__ + "4fab9ea51c1fddd424188e91f104434a.svg";